import { popAuthorityPlans, whiteGlovePlans } from '@/components/plans_constants'
import { getPureServicePkgName } from '@/utils'

/**
 * Program filter of the account selector shown to the POP team accounts (mission control, White
 * Glove staff): they have access to every managed account, so the list is split by the program
 * of the account owner.
 */
export const ACCOUNT_PROGRAM_ALL = 'all'
export const ACCOUNT_PROGRAM_POP_AUTHORITY = 'pop_authority'
export const ACCOUNT_PROGRAM_WHITE_GLOVE = 'white_glove'
export const ACCOUNT_PROGRAM_OTHER = 'other'

export const ACCOUNT_PROGRAM_FILTERS = [
  { key: ACCOUNT_PROGRAM_ALL, label: 'All' },
  { key: ACCOUNT_PROGRAM_POP_AUTHORITY, label: 'POP Authority' },
  { key: ACCOUNT_PROGRAM_WHITE_GLOVE, label: 'White Glove' },
  { key: ACCOUNT_PROGRAM_OTHER, label: 'Other' },
]

const pure = (plans) => plans.map((plan) => getPureServicePkgName(plan))
const POP_AUTHORITY_TYPES = pure(popAuthorityPlans)
// whiteGlovePlans is the whole family: POP Authority is checked first
const WHITE_GLOVE_TYPES = pure(whiteGlovePlans)

/** pop_authority | white_glove | other, from the account type of the relation's owner. */
export function accountProgramOfRelation (relation) {
  const type = getPureServicePkgName((relation && relation.ownerAccountType) || '') || ''
  if (POP_AUTHORITY_TYPES.includes(type)) return ACCOUNT_PROGRAM_POP_AUTHORITY
  if (WHITE_GLOVE_TYPES.includes(type)) return ACCOUNT_PROGRAM_WHITE_GLOVE
  return ACCOUNT_PROGRAM_OTHER
}

/**
 * The relations of one program. The account in use (`selected`) stays in the list whatever the
 * filter, so the selector never shows an empty field for it.
 */
export function filterRelationsByProgram (relations, filterKey, selected = null) {
  const list = relations || []
  if (!filterKey || filterKey === ACCOUNT_PROGRAM_ALL) return list
  const selectedId = selected && selected.id
  return list.filter((relation) => (
    accountProgramOfRelation(relation) === filterKey || (selectedId != null && relation.id === selectedId)
  ))
}

/** { all, pop_authority, white_glove, other }: how many accounts each tab holds. */
export function accountProgramCounts (relations) {
  const counts = {
    [ACCOUNT_PROGRAM_ALL]: 0,
    [ACCOUNT_PROGRAM_POP_AUTHORITY]: 0,
    [ACCOUNT_PROGRAM_WHITE_GLOVE]: 0,
    [ACCOUNT_PROGRAM_OTHER]: 0,
  }
  for (const relation of relations || []) {
    counts[ACCOUNT_PROGRAM_ALL] += 1
    counts[accountProgramOfRelation(relation)] += 1
  }
  return counts
}

/** True for the POP team accounts (mission control, White Glove staff): the tabs are theirs only. */
export function isTeamAccessAccount (relations) {
  return (relations || []).some(
    (relation) => relation.isMissionControlSubAccount || relation.isWhiteGloveStaffSubAccount
  )
}
